module.exports = __webpack_public_path__ + "resources/img/equipment_tab_img_m.e6e2408c48bbd9f2c389631e018611a0.jpg";